





































import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { Address, DebitCardDeactivationReasons, DebitCardManagerModalViewState, CardStatus } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import { Validator } from "vee-validate";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
    }
})
export default class RequestNewCardConfirmForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();
    DebitCardManagerModalViewState = DebitCardManagerModalViewState;

    RouteNames = RouteNames;

    formIsBeingSubmitted = false;

    get mailingAddress (): Address {
        return this.debitCardManagementStore.mailingAddress;
    }

    onSubmitChanges (e: Event) {
        e.preventDefault();
        this.orderCard();
    }

    orderCard () {
        this.formIsBeingSubmitted = true;
        let cardOrderPromise: () => Promise<any>;

        if (this.debitCardManagementStore.pendingNewCardHolder !== null) {
            if (this.debitCardManagementStore.hasPrimaryCard === false) {
                cardOrderPromise = () => this.debitCardManagementStore.orderCardForPrimaryAndDependent(
                    this.debitCardManagementStore.pendingNewCardHolder);
            } else {
                cardOrderPromise = () => this.debitCardManagementStore.orderCardForDependent(
                    this.debitCardManagementStore.pendingNewCardHolder);
            }
        } else {
            if (this.debitCardManagementStore.hasPrimaryCard) {
                cardOrderPromise = () => this.debitCardManagementStore.orderDuplicatePrimaryDebitCard();
            } else {
                cardOrderPromise = () => this.debitCardManagementStore.orderPrimaryCard();
            }
        }

        cardOrderPromise()
            .finally(() => {
                this.formIsBeingSubmitted = false;
                this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.RequestNewCardCompleteForm);
            });
    }
}
